const roundTo = (number = 0, fractionDigits = 2) => {
  const fraction = 10 ** fractionDigits;

  return Math.round(number * fraction) / fraction;
};

export default roundTo;
